module.exports = __webpack_public_path__ + "img/taipei.c1706de2.jpg";